import React from "react";
import Navbar from "../Components/Navbar";
import Home_Container from "../Components/Home_Container";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Home_Container />
    </div>
  );
};

export default Home;
